export default function menu() {
  /* Focus trap sticky nav and mobile nav */
  const menuRight = document.querySelector('.sub-menu-right');
  const menuToggles = document.querySelectorAll('.menu-toggle');
  const focusableElementsString = 'a[href], button:not([disabled])';

  let focusableElements = [];
  let firstFocusableElement;
  let lastFocusableElement;

  function handleTogglesExpand() {
    for (const menuToggle of menuToggles) {
      if (menuRight.classList.contains('toggled')) {
        menuToggle.setAttribute('aria-expanded', 'true');
      } else {
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  const updateFocusableElements = () => {
    focusableElements = menuRight.querySelectorAll(focusableElementsString);
    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && menuRight.classList.contains('toggled')) {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        // Just tab
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  };

  for (const menuToggle of menuToggles) {
    menuToggle.addEventListener('click', function () {
      handleTogglesExpand();

      if (menuToggle.ariaExpanded === 'true') {
        updateFocusableElements();
        firstFocusableElement.focus();
      } else if (menuToggle.ariaExpanded === 'false') {
        menuToggle.focus();
      }
    });
  }
  document.addEventListener('keydown', handleKeyDown);

  /* Close submenu on escape or enter key */
  const primaryMenu = document.getElementById('primary-menu');
  const subMenu = primaryMenu.querySelector('.sub-menu');
  const subMenuLinks = subMenu.querySelectorAll('a');
  const menuParent = primaryMenu.querySelector('.menu-item-has-children');
  const menuParentAnchor = primaryMenu.querySelector(
    '.menu-item-has-children > a'
  );

  if (subMenu) {
    menuParent.setAttribute('aria-expanded', 'false');

    menuParent.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const isExpanded = menuParent.getAttribute('aria-expanded') === 'true';

        if (!isExpanded) {
          openSubMenu(menuParent, subMenu);
        } else {
          closeSubMenu(menuParent, subMenu);
        }
      }
    });

    subMenuLinks.forEach((subMenuLink) => {
      subMenuLink.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeSubMenu(menuParent, subMenu);
          menuParentAnchor.focus();
        } else if (e.key === 'Enter') {
          subMenuLink.click();
        }
      });
    });

    subMenu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSubMenu(menuParent, subMenu);
        menuParentAnchor.focus();
      }
    });

    subMenu.addEventListener('focusout', function(e) {
      const relatedTarget = e.relatedTarget;
    
      if (!subMenu.contains(relatedTarget)) {
        closeSubMenu(menuParent, subMenu);
      }
    });

    function openSubMenu(menuParent, subMenu) {
      subMenu.classList.add('show');
      menuParent.setAttribute('aria-expanded', 'true');
    }

    function closeSubMenu(menuParent, subMenu) {
      subMenu.classList.remove('show');
      menuParent.setAttribute('aria-expanded', 'false');
      menuParentAnchor.focus();
    }
  }
}
